<div class="db-tabs">
  <div class="db-tabs__heads">
    <div>
      <ng-content select="db-tab-head"></ng-content>
    </div>
  </div>

  <div class="db-tabs__main-content">
    <div class="db-tabs__subheads" *ngIf="hasContent">
      <ng-content select="db-tab-subhead"></ng-content>
    </div>

    <div class="db-tabs__contents">
      <ng-content select="db-tab-content"></ng-content>
    </div>
  </div>
</div>
